// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lXxX","buttons":"styles_buttons__20UlN"};